<script>
  import ConversationDetailsPanel from './conversation-details/ConversationDetailsPanel.svelte';

  export let conversationId;
  export let onLeft = () => {};
</script>

<ConversationDetailsPanel {conversationId} {onLeft} />
